import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Button from 'components/Button/Button';

import IGEAR from 'static/img/igear.svg';
import BackImage from 'static/img/img-banner-aragon.jpg';
import LogoGobierno from 'static/img/gobierno_color_transparente_white.png';
import LogoGobiernoWhite from 'static/img/gobierno_white.png';

import './HomePage.css';

declare var CONFIGURATIONS;
declare var HOME_PAGE;

class HomePage extends Component {

  goVisor = () => {
    const url = window.location.href.split('/fototeca/')[0] + '/fototeca/visor';
    window.location.href = url;
  }

  goHelp = () => {
    window.open(CONFIGURATIONS.guide_url);
  }

  render() {
    return (
      <div className='homepage-container'>
        <div className='homepage-header' style={{ backgroundImage: `url(${BackImage})` }}>
          <div className="logo-gobierno">
            <img src={LogoGobierno} alt='Logo del gobierno'/>
          </div>
          <div>
            <div className='homepage-title'>FOTOTECA DIGITAL DE ARAGÓN</div>
          </div>
        </div>
        <div className='homepage-content'>
          <div>
            <div>
              <img src={IGEAR} alt='IGEAR'/>
            </div>
            <div dangerouslySetInnerHTML={{ __html: HOME_PAGE.text }} /> 
          </div>
          <div className='row'>
            <Button text={'Acceso a Fototeca Digital'} active={true} onClick={this.goVisor} />
            <Button text={'Manual de uso'} active={true} onClick={this.goHelp} />
          </div>
        </div>
        <footer>
          <div>
            © {new Date().getFullYear()} Instituto Geográfico de Aragón. Todos los derechos reservados.<br/> Ed. Pignatelli. Paseo María Agustín, 36 puerta 14 planta 3, 50071 Zaragoza. Tel. +34 976 71 56 05
          </div>
          <div>
            <a href="https://icearagon.aragon.es/accesibilidad.jsp" target="_blank" rel="noreferrer noopener">ACCESIBILIDAD</a>
            <a href="https://icearagon.aragon.es/portal/politica-privacidad.jsp" target="_blank" rel="noreferrer noopener">AVISO LEGAL. PROTECCIÓN DE DATOS</a>
            <a href="https://icearagon.aragon.es/mapa-web.jsp" target="_blank" rel="noreferrer noopener">MAPA WEB</a>
            <a href="mailto:igear@aragon.es" target="_blank" rel="noreferrer noopener">CONTACTO</a>
          </div>
          <div>
            <a href="https://www.aragon.es/" target="_blank" rel="noreferrer noopener">
              <img src={LogoGobiernoWhite} alt='Logo del gobierno en blanco' />
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default translate()(HomePage);
